import { useEvieAppContext } from '../EvieAppProvider';

export const useCompletedActivity = (activityId) => {
  const { completedExSqActivities = [] } = useEvieAppContext();

  const isActivityCompleted = completedExSqActivities.find(({ id: actId }) => actId === activityId);

  return { completedActivity: isActivityCompleted };
};
